// The releases file scripts/coding-stats.mjs writes on every deploy (/coding-stats.json): each version's
// date, one-line summary and how much code it changed. Read by Administration › Coding stats, and by the
// Audit log for the summary of each "New version launched" row.
import { useQuery } from '@tanstack/react-query';

export interface Release {
  version: string;
  date: string;
  title: string;
  commit: string;
  commits: number;
  files: number;
  insertions: number;
  deletions: number;
}
export interface CodingStatsFile { generatedAt: string; excluded: string[]; releases: Release[] }

export function useCodingStats(opts?: { enabled?: boolean }) {
  return useQuery({
    queryKey: ['coding-stats'],
    queryFn: async () => {
      const r = await fetch('/coding-stats.json', { cache: 'no-cache', credentials: 'same-origin' });
      if (!r.ok) throw new Error(`Couldn't load the coding stats (${r.status}).`);
      return (await r.json()) as CodingStatsFile;
    },
    staleTime: 10 * 60_000,
    enabled: opts?.enabled ?? true,
  });
}

/** a release's one-line summary by its version ('v2.0.19.19' or '2.0.19.19'), '' when it has none. */
export function releaseTitleOf(file: CodingStatsFile | undefined, version: string | null | undefined): string {
  const want = (version ?? '').trim().replace(/^v/i, '');
  if (!want || !file) return '';
  return file.releases.find((r) => r.version.replace(/^v/i, '') === want)?.title.trim() ?? '';
}
